export default function WelcomeCard() {
  return (
    <div className="bg-background-50 rounded-xl border border-primary-200/50 p-4">
      <p className="text-sm text-primary-600 font-medium mb-1">👋 姐妹,欢迎来到郡主的直播间!</p>
      <p className="text-sm text-foreground-500 leading-relaxed">
        填写这份表格只需 5-8 分钟,填完截图或复制发给我,我来帮你分析身体状况,
        <span className="font-semibold text-primary-600">完全免费,不推销</span>。
      </p>
    </div>
  );
}